import React, { useState, useEffect, useRef } from 'react';
import { Modal, Button, Form, Container, Card, Tooltip, Overlay } from "react-bootstrap";
import { FaTimes } from "react-icons/fa";


const VideoPopUp = ({
    show,
    handleClose,
    title,
    url,
    iframe
}) => {

    return (
        <>
            <Modal show={show} onHide={handleClose} backdrop="static">
                <Modal.Body className='videopopup-modal-body'>
                    <Container>
                        <Card className={`mx-auto rounded-border-px custom-shadow border-none`}>
                            <Card.Body className={`d-flex flex-column align-items-center m3`}>
                                <p className="modal-title ">{title}</p>
                               {url?
                                <iframe src={url} 
                                width="900" height="550" 
                                frameborder="0" 
                                className='custom-shadow-bold'
                                allow="autoplay; fullscreen; picture-in-picture" 
                                allowfullscreen></iframe>
                                :

                                <div className={"videopopup-modal-iframe"} dangerouslySetInnerHTML={{ __html: iframe }}></div>
                                
                                }

                                <Button
                                    variant="none"
                                    className="modal-close-button"
                                    onClick={handleClose}
                                >
                                    <FaTimes className="mb-1" />
                                </Button>


                            </Card.Body>
                        </Card>
                    </Container>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default VideoPopUp;
